<template>
    <div class="portlet light portlet-fit">
      <div class="portlet-title">
          <div class="caption">
              <i class="icon-pencil font-red-sunglo"></i>
              <span class="caption-subject font-red-sunglo uppercase bold">Rédiger une News</span>
          </div>
      </div>
      <div class="portlet-body">
          <div class="row">
              <div class="col-md-8 col-md-offset-2 col-xs-12">
                  <div class="portlet light" style="border: 1px solid #C2CAD8; margin-right: 1em;">
                      <div>
                          <div class="ss-titre text-center">
                              <strong>Photo d'illustration</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
                          </div>
                          <v-image-upload
                              :oldImage="illustrationImage"
                              :ratio="16/9"
                              name="illustration"
                              @image="addNewImage">
                          </v-image-upload>
                      </div>
                  </div>
                  <span class="help-block"></span>
              </div>
          </div>
          <div class="row">
              <div class="col-md-8 col-md-offset-2 col-xs-12">
                  <div class="portlet light" style="border: 1px solid #C2CAD8; margin-right: 1em;">
                    <div class="ss-titre">
                        <strong>Contenu</strong>
                    </div>
                    <v-input type="text" name="title" title="Titre" v-model="newPost.title"></v-input>
                    <v-ckeditor name="content" title="Contenu" v-model="newPost.content"></v-ckeditor>
                    <div class="row">
                      <div class="col-xs-12">
                          <v-video v-model="newPost.videoEmbed"></v-video>
                      </div>
                    </div>
                    <button class="btn btn-block green" id="btn-post" @click="save"> Sauvegarder le contenu</button>
                  </div>
              </div>
          </div>
          <div class="row" v-if="status === 'edition'">
              <div class="col-md-8 col-md-offset-2 col-xs-12">
                  <div class="portlet light" style="padding: 0!important">
                    <div class="row">
                      <div class="col-xs-12">
                        <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
                          <div class="text-center ss-titre">
                            <strong>Portfolio d'images</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
                          </div>
                           <v-image-upload
                              :key="imageKey"
                              name="portfolio"
                              :display="false"
                              @image="addNewImage"
                              @validated="sendImage">
                          </v-image-upload>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="is_portfolio">
                      <div class="ss-titre">
                        <span class="font-red-sunglo uppercase bold">Images ajoutées :</span>
                      </div>
                      <div class="portlet-body">
                        <div class="portlet light">
                          <div class="mt-element-card mt-element-overlay" v-for="(image, index) in portfolioImages">
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                              <div class="mt-card-item boxShadowGreen">
                                <div class="mt-card-avatar mt-overlay-1" style="background-color: #C7C89E;">
                                  <img :src="`/${image.optimized}`" class="containCardImg">
                                  <div class="mt-overlay">
                                    <button class="btn btn-danger btn-outline btnCard pull-right btnRadius" @click="deleteImage(image, index)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="help-block"></span>
              </div>
          </div>
          <div class="row">
              <div class="col-md-8 col-md-offset-2 col-xs-12">
                  <button class="btn btn-block green" id="btn-post" @click="sendPost" v-if="status === 'creation'">Sauvegarder et ajouter un portfolio d'images</button>
                  <button class="btn btn-block green" style="margin-right: 13px" @click="redirect"> Tout sauvegarder et quitter</button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {

  name: 'blog-form',
  props: {
    post: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      newPost: Object.assign({}, this.post),
      image: new vImageHelper(),
      portfolioImages: this.post.images.find(img=>img.name == 'portfolio'),
      illustrationImage: this.post.images.find(img=>img.name == 'illustration'),
      imageKey: 0,
      met: 'post',
      status: 'creation'
    }
  },
  computed: {
    is_portfolio() {
      return this.portfolioImages.items.length > 0 ? true : false
    }
  },
  mounted () {
    if (Object.keys(this.post).length > 1) this.met = 'put'
    if (Object.keys(this.post).length > 1) this.status = 'edition'
  },
  methods:{
    addNewImage(event) {
      this.image.add(event)
    },
    save() {
      this.sendPost(() => {
        this.redirect()
      })

    },
    async sendPost(callback) {
      const response = await axios[this.met](this.met === 'post' ? '/post' : `/post/${this.newPost.id}`, this.newPost)

      this.newPost = response.data.post

      this.image.send(`/post/${response.data['post'].id}/image/illustration`, () => {
        typeof callback === 'function' && callback()
      })

      this.$snotify.success(this.successMsg())

      this.status = 'edition'
    },
    async sendImage() {
      this.image.send(`/post/${this.newPost.id}/image/portfolio/create`, () => {
        this.portfolioImages.push(this.image.response.image)

        this.imageKey += 1
      })
    },
    async deleteImage(image, index) {
      this.$delete(this.portfolioImages.items, index)
      console.log(image, index)
      await axios.delete(`/post/image/${image.id}`)
      this.$snotify.success("L'image a bien été supprimée")
    },
    successMsg() {
      return this.met === 'post' ? 'News créée avec succès' : 'News mise a jour avec succès'
    },
    redirect() {
      setTimeout(() => {
          window.location.href = '/post'
      }, 1000)
    }
  }
};
</script>

<style lang="css" scoped>
</style>
